import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';

const StopBlackboxLoggerModal = ({ show, close, onConfirm }) => {
    const { t: translate } = useTranslation();

    const renderContent = (translate) => {
        return (
            <div className='stop-blackbox-logger-modal-content' id='stop-blackbox-logger-modal-content'>
                <p id='stop-blackbox-logger-modal-message'>{translate('ABB.Powertrain.Frontend.stopBlackboxLoggerMessage')}</p>
                <p id='stop-blackbox-logger-modal-note' className='mt-2'>{translate('ABB.Powertrain.Frontend.stopBlackboxLoggerNote')}</p>
            </div>
        );
    };

    return <GeneralDialog
        modalClassName='stop-blackbox-logger-modal'
        show={show}
        close={close}
        closeButton={true}
        title={translate('ABB.Powertrain.Frontend.stopBlackboxLoggerTitle')}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.stopBlackboxLoggerContinueLabel'),
            onClick: onConfirm
        }}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
            onClick: close
        }}
        id='stop-blackbox-logger-modal'
    >
        {renderContent(translate)}
    </GeneralDialog>;
};

StopBlackboxLoggerModal.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    onConfirm: PropTypes.func
};

export default StopBlackboxLoggerModal;
